<template>
<svg
    width="12px"
    height="12px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
>
    <title>trash-icon</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g fill="#FFFFFF" fill-rule="nonzero">
        <!-- Tapa del contenedor de la papelera -->
        <path
        d="M9,3 L15,3 C15.552,3 16,3.448 16,4 L16,5 L20,5 L20,7 L4,7 L4,5 L8,5 L8,4 C8,3.448 8.448,3 9,3 Z"
        opacity="0.8"
        class="color-background"
        ></path>
        <!-- Cuerpo de la papelera -->
        <path
        d="M5,7 L19,7 L18,20 C18,20.552 17.552,21 17,21 L7,21 C6.448,21 6,20.552 6,20 L5,7 Z"
        class="color-foreground"
        ></path>
        <!-- Línea divisoria para los contenedores internos -->
        <path
        d="M10,11 L10,17"
        stroke="#FFFFFF"
        stroke-width="2"
        stroke-linecap="round"
        ></path>
        <path
        d="M14,11 L14,17"
        stroke="#FFFFFF"
        stroke-width="2"
        stroke-linecap="round"
        ></path>
    </g>
    </g>
</svg>
</template>

<script>
export default {
name: "TrashIcon",
};
</script>
